// @flow
import React from 'react';
import classnames from 'classnames';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import Image from 'Components/frameworks/image/Image.jsx';

export type FooterPoliciesProps = Array<{
  imageSrc: string,
  label: string,
  url: string,
}>;

export function FooterPolicies({
  className,
  items = [],
}: {
  className?: string,
  items: FooterPoliciesProps,
}) {
  if (!items.length) {
    return null;
  }

  return (
    <ul className={classnames(className, 'reset-list text-sm')}>
      {items.map(({ imageSrc, label, url }) => (
        <li className="my-1" key={url}>
          <DynamicLink
            className="reset-anchor inline-flex items-center text-white focus:text-gray-light hover:text-gray-light"
            url={url}
          >
            <Image className="flex-shrink-0 rtl:mr-1" dontChangeAnything imageUrl={imageSrc} />
            {label}
          </DynamicLink>
        </li>
      ))}
    </ul>
  );
}
